export const RUPEE = '₹';

export const DOCUMENT_EXTENSIONS = ['image/jpeg', 'image/png', 'image/jpg'];
// export const DOCUMENT_EXTENSIONS = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];

export const isHoverSupported = typeof window !== "undefined" && window.matchMedia("(hover: hover)").matches;